<template>
    <stitchedBg v-bind="configBg">
        <div class="content">
            <slot></slot>
        </div>
    </stitchedBg>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import stitchedBg from "@activity-business/h5-package-stitchedBg";

const configBg = {
    domain: DOMAIN.H5_IMAGE_DOMAIN,
    projectName: "202411_PreludeRank",
    bgList: {
        top: { 
            imgName: 'top', 
            height: '3.74rem'
        },
        center: { 
            imgName: 'mid', 
            height: '1.08rem'
        },
        bottom: { 
            imgName: 'btm', 
            height: '1.36rem'
        }
    },
    bgWidth: '7.02rem',
}

</script>

<style lang="scss" scoped>
@use '@page/202411/PreludeRank/scss/public_mixin.scss' as *;
.content {
    min-height: 6.18rem;
}
</style>
